import styled, {keyframes} from 'styled-components';
import { useNavigate } from 'react-router-dom';

//Images
import HEADER from '../images/new_header.jpeg';
import OPEN from '../images/admission-open.png';



const pop = keyframes`
      0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.2);
    }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100vw - 50px);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  height: 90vh;
  background-image: url(${HEADER});
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  z-index: 1;

  //breakpoint for mobile
  @media (max-width: 480px) {
    height: 60vh;
    width: calc(100vw - 10px);
    margin: 5px 0px;
  }
`;

const Main = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
  position: relative;
`;

const Open = styled.div`
  height: 150px;
  width: 150px;
  position: absolute;
  bottom: 20px;
  right: 10px;
  animation: ${pop} 1s infinite;
  //breakpoint for mobile
  @media (max-width: 480px) {
    height: 60px;
    width: 60px;
    bottom: 10px;
    right: 10px;
  }
`

const OpenImage = styled.img`
  height: 100%;
  width: 100%;
`

const Info = styled.div`
  display: flex;
  margin: 40px;
  flex-direction: column;
  align-items: center;
  z-index: 3;
  gap: 20px;
`;

const Title = styled.h1`
  font-size: 64px;
  color: #fecb0f;
  margin: 0;
  padding: 0;
  @media (max-width: 480px) {
    font-size: 30px;
    text-align: center;
  }
`;

const Desc = styled.p`
  font-size: 34px;
  color: #fff;
  padding: 10px;
  margin: 0;
  text-align: center;
  border: 2px dashed #fecb0f;
  font-weight: 600;
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const SubHeading = styled.h2`
  font-size: 40px;
  color: #f6ff00;
  margin: 0;
  padding: 0;
  text-align: center;
  @media (max-width: 480px) {
    font-size: 30px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 20px;

  //breakpoint of mobile
  @media (max-width: 480px) {
    display: none;
  }
`;

const Button = styled.button`
  padding: 20px 30px;
  font-size: 30px;
  font-weight: 800;
  color: #000000;
  background-color: #fecb0f;
  border: 5px solid white;
  border-radius: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background-color: #ff6665;
  }
`;

const Coaching = styled.div`
  position: absolute;
  top: -30px;
  right: 20px;
  width: 300px;
  height: 180px;
  background-color: #ff4040;
  z-index: 4000000;
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(100% 50%,89.45% 56.58%,97.29% 66.23%,85.18% 69.04%,89.46% 80.71%,77.09% 79.43%,77.35% 91.86%,66.07% 86.63%,62.27% 98.47%,53.3% 89.86%,45.87% 99.83%,40.18% 88.78%,29.92% 95.79%,28.12% 83.49%,16.14% 86.79%,18.43% 74.57%,6.03% 73.8%,12.17% 62.99%,0.68% 58.23%,10% 50%,0.68% 41.77%,12.17% 37.01%,6.03% 26.2%,18.43% 25.43%,16.14% 13.21%,28.12% 16.51%,29.92% 4.21%,40.18% 11.22%,45.87% 0.17%,53.3% 10.14%,62.27% 1.53%,66.07% 13.37%,77.35% 8.14%,77.09% 20.57%,89.46% 19.29%,85.18% 30.96%,97.29% 33.77%,89.45% 43.42%);
  /* Create blue edge effect and shadow on lower side */
  box-shadow: 0 0 0 8px #1a237e, 0 15px 15px rgba(0, 0, 0, 0.5);
  
  @media (max-width: 480px) {
    width: 150px;
    height: 100px;
    top: 10px;
    right: -10px;
    box-shadow: 0 0 0 5px #1a237e, 0 10px 10px rgba(0, 0, 0, 0.5);
  }
`;

const CoachingText = styled.p`
  color: white;
  font-size: 20px;
  margin: 0;
  padding: 0 15px;
  text-align: center;
  font-weight: bold;
  
  @media (max-width: 480px) {
    font-size: 9px;
    padding: 0 10px;
  }
`;

function Banner({handleScroll}) {
  const navigate = useNavigate();


  const handleClick = (link) => {
    navigate(`/${link}`);
  };

  return (
    <Container>
      <Main>
        <Coaching>
          <CoachingText>Evening coaching<br />classes also available<br />(Nursery to 8th)</CoachingText>
        </Coaching>
        <Info>
          <Title>New Blooming Buds School</Title>
          <Desc>
            New Blooming Buds School is a school for Play to V.
          </Desc>
          <SubHeading>Prepare Your Child For Success In Life.</SubHeading>

          <ButtonContainer>
            <Button onClick={() => handleClick('enroll')}>Enroll Now</Button>
            <Button onClick={() => handleClick('Contact')}>Contact Us</Button>
          </ButtonContainer>
        </Info>

        <Open>
          <OpenImage src={OPEN} alt="Open" />
        </Open>

      </Main>
    </Container>
  );
}

export default Banner;